import { render } from "./PartyIcon.vue?vue&type=template&id=b262183e"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/PartyIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b262183e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b262183e', __exports__)) {
    api.reload('b262183e', __exports__)
  }
  
  module.hot.accept("./PartyIcon.vue?vue&type=template&id=b262183e", () => {
    api.rerender('b262183e', render)
  })

}


export default __exports__